import * as TYPE from '../util/types'
import Vue from 'vue'

import router from '~/router/index'

const state = {
	dontTriggerPop: false,
	activeModalStack: [],
	permissionsPromptModal: false,
	permissionsPromptModalType: null,
	addonUpsellModal: false,
	purchaseAddonModal: false,
	purchaseAddonSuccessModal: false,
	registrationConfirmationModal: false,
	denyGuestConfirmationModal: false,
	activeEventTimerModal: false,
	activeEventChatModal: false,
	hostProcessModal: false,
	hostProcessModalPage: '',
	whyLinkedinModal: false,
	aboutUsModal: false,
	shareModal: false,
	shareModalEvent: null,
	calendarModal: false,
	calendarModalEvent: null,
	eventRSVPSuccessModal: false,
	eventRSVPSuccessModalEvent: null,
	eventRSVPSuccessModalAddons: false,
	contactForm: false,
	editEventContactForm: false,
	editEventContactFormEvent: null,
	paymentModal: false,
	paymentModalEvent: null,
	paymentModalAddons: null,
	paymentModalStatus: null,
	membershipUpsellModal: false,
	membershipUpsellModalEvent: null,
	termsModal: false,
	termsActivePage: 0,
	showPrivacyModal: false,
	genericModal: false,
	genericModalText: [''],
	genericModalTitle: '',
	mobileNavActive: '',
	snackbarOpen: false,
	snackbarText: '',
	eventHostModal: false,
	eventAttendeesModal: false,
	eventLocationModal: false,
	eventGuestRequirementsModal: false,
	eventContactHostModal: false,
	eventContactGuestModal: false,
	eventContactAllGuestsModal: false,
	eventReportEventModal: false,
	eventCancellationPolicyModal: false,
	eventGuestModal: false,
	eventGuestModalIndex: 0,
	eventCohostModal: false,
	eventCohostModalIndex: 0,
	eventModalEvent: null
}

const mutations = {
	[TYPE.SET_ACTIVE_MODAL]: (state, value) => {
		state.activeModalStack.push(value)
	},
	[TYPE.SET_DONT_TRIGGER_POP]: (state, value) => {
		state.dontTriggerPop = value
	},
	[TYPE.POP_ACTIVE_MODAL]: (state, value) => {
		state.activeModalStack.pop()
	},
	[TYPE.SET_MODAL_PROP]: (state, payload) => {
		// Vue.set(state, payload.prop, payload.value)
		state[payload.prop] = payload.value
	},
	[TYPE.SET_EVENT_RSVP_MODAL_EVENT]: (state, payload) => {
		state.eventRSVPSuccessModalEvent = payload
		state.showEventRSVPSuccessModal = true
	},
	[TYPE.SET_SHARE_MODAL_EVENT]: (state, payload) => {
		state.shareModalEvent = payload
	},
	[TYPE.SET_CALENDAR_MODAL_EVENT]: (state, payload) => {
		state.calendarModalEvent = payload
	},
	[TYPE.SET_EDIT_EVENT_CONTACT_FORM_EVENT]: (state, payload) => {
		state.editEventContactFormEvent = payload
	},
	[TYPE.SET_TERMS_PAGE]: (state, value) => {
		state.termsActivePage = value
	},
	[TYPE.SET_PAYMENT_MODAL_EVENT]: (state, payload) => {
		state.paymentModalEvent = payload
	},
	[TYPE.SET_PAYMENT_MODAL_STATUS]: (state, payload) => {
		state.paymentModalStatus = payload
	},
	[TYPE.SET_MEMBERSHIP_UPSELL_MODAL_EVENT]: (state, payload) => {
		state.membershipUpsellModalEvent = payload
	},
	[TYPE.SET_GENERIC_MODAL_TEXT]: (state, payload) => {
		state.genericModalText = payload
	},
	[TYPE.SET_GENERIC_MODAL_TITLE]: (state, payload) => {
		state.genericModalTitleS = payload
	},
	[TYPE.SET_MOBILE_NAV_ACTIVE]: (state, payload) => {
		state.mobileNavActive = payload
	},
	[TYPE.SET_SNACKBAR_OPEN]: (state, payload) => {
		state.snackbarOpen = payload
	},
	[TYPE.SET_SNACKBAR_TEXT]: (state, payload) => {
		state.snackbarText = payload
	},
	[TYPE.OPEN_RSVP_SUCCESS_MODAL]: state => {
		state.paymentModal = false
		state.activeModalStack = []
		state.eventRSVPSuccessModal = true
		state.activeModalStack.push('eventRSVPSuccessModal')
	},
	[TYPE.OPEN_PURCHASE_ADDON_SUCCESS_MODAL]: state => {
		state.purchaseAddonModal = false
		state.activeModalStack = []
		state.purchaseAddonSuccessModal = true
		state.activeModalStack.push('purchaseAddonSuccessModal')
	},
	[TYPE.OPEN_PURCHASE_ADDON_MODAL]: state => {
		state.addonUpsellModal = false
		state.activeModalStack = []
		state.purchaseAddonModal = true
		state.activeModalStack.push('purchaseAddonModal')
	}
}

const actions = {
	openPurchaseAddonModal({commit}) {
		commit(TYPE.OPEN_PURCHASE_ADDON_MODAL)
	},
	openPurchaseAddonSuccessModal({commit}) {
		commit(TYPE.OPEN_PURCHASE_ADDON_SUCCESS_MODAL)
	},
	openRSVPSuccessModal({ commit }) {
		commit(TYPE.OPEN_RSVP_SUCCESS_MODAL)
	},
	popActiveModal({ commit }) {
		commit(TYPE.POP_ACTIVE_MODAL)
	},
	setDontTriggerPop({ commit }, value) {
		commit(TYPE.SET_DONT_TRIGGER_POP, value)
	},
	setModalOpen({ commit, state }, payload) {
		if (payload.value === true) {
			commit(TYPE.SET_ACTIVE_MODAL, payload.prop)
			if (
				router.history.current.path.indexOf('redirect') ||
				router.history.current.path.indexOf('notif')
			) {
				router.replace({ path: router.history.current.path })
			}
			router.push({
				path: router.history.current.path + '?modal=' + payload.prop
			})
		} else {
			if (state.activeModalStack.length > 0) {
				commit(TYPE.POP_ACTIVE_MODAL)
				if (!state.dontTriggerPop) {
					commit(TYPE.SET_DONT_TRIGGER_POP, true)
					router.replace({ path: router.history.current.path })
					router.go(-1)
				} else {
					commit(TYPE.SET_DONT_TRIGGER_POP, false)
				}
			}
		}
		commit(TYPE.SET_MODAL_PROP, payload)
	},
	setModalProp({ commit }, payload) {
		commit(TYPE.SET_MODAL_PROP, payload)
	},
	setAdminProp({ commit }, payload) {
		commit(TYPE.SET_ADMIN_PROP, payload)
	},
	setEventRSVPSuccessModalEvent({ commit }, payload) {
		commit(TYPE.SET_EVENT_RSVP_MODAL_EVENT, payload)
	},
	setShareModalEvent({ commit }, payload) {
		commit(TYPE.SET_SHARE_MODAL_EVENT, payload)
	},
	setCalendarModalEvent({ commit }, payload) {
		commit(TYPE.SET_CALENDAR_MODAL_EVENT, payload)
	},
	setTermsPage({ commit }, value) {
		commit(TYPE.SET_TERMS_PAGE, value)
	},
	setEditEventContactFormEvent({ commit }, payload) {
		commit(TYPE.SET_EDIT_EVENT_CONTACT_FORM_EVENT, payload)
	},
	setPaymentModalEvent({ commit }, payload) {
		commit(TYPE.SET_PAYMENT_MODAL_EVENT, payload)
	},
	setPaymentModalStatus({ commit }, payload) {
		commit(TYPE.SET_PAYMENT_MODAL_STATUS, payload)
	},
	setMembershipUpsellModalEvent({ commit }, payload) {
		commit(TYPE.SET_MEMBERSHIP_UPSELL_MODAL_EVENT, payload)
	},
	setGenericModalText({ commit }, payload) {
		commit(TYPE.SET_GENERIC_MODAL_TEXT, payload)
	},
	setGenericModalTitle({ commit }, payload) {
		commit(TYPE.SET_GENERIC_MODAL_TITLE, payload)
	},
	setMobileNavActive({ commit }, payload) {
		commit(TYPE.SET_MOBILE_NAV_ACTIVE, payload)
	},
	setSnackbarOpen({ commit }, payload) {
		commit(TYPE.SET_SNACKBAR_OPEN, payload)
	},
	setSnackbarText({ commit }, payload) {
		commit(TYPE.SET_SNACKBAR_TEXT, payload)
	}
}

const getters = {
	getDontTriggerPop: state => state.dontTriggerPop,
	getModalProp: state => prop => state[prop],
	getActiveModal: state =>
		state.activeModalStack[state.activeModalStack.length - 1],
	getShareModalEvent: state => state.shareModalEvent,
	getCalendarModalEvent: state => state.calendarModalEvent,
	getEventRSVPSuccessModalEvent: state => state.eventRSVPSuccessModalEvent,
	getTermsPage: state => state.termsActivePage,
	getEditEventContactFormEvent: state => state.editEventContactFormEvent,
	getPaymentModalEvent: state => state.paymentModalEvent,
	getPaymentModalStatus: state => state.paymentModalStatus,
	getMembershipUpsellModalEvent: state => state.membershipUpsellModalEvent,
	getGenericModalText: state => state.genericModalText,
	getGenericModalTitle: state => state.genericModalTitle,
	getMobileNavActive: state => state.mobileNavActive,
	getSnackbarOpen: state => state.snackbarOpen,
	getSnackbarText: state => state.snackbarText
}

export default {
	state,
	mutations,
	actions,
	getters
}
